module.exports = __webpack_public_path__ + "media/movie.d77f6745.mp4";